mutation LookupAccountDelete($input: LookupAccountDeleteInput!) {
  lookupAccountDelete(input: $input) {
    clientMutationId
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
